"use strict";

var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/vercel/path0/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js");

var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/regenerator/index.js");

var _defineProperty = require("/vercel/path0/node_modules/@babel/runtime/helpers/defineProperty.js");

var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("core-js/modules/es.object.from-entries.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps( // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // pkg/dist-src/index.js


var dist_src_exports = {};

__export(dist_src_exports, {
  OAuthApp: function OAuthApp() {
    return _OAuthApp;
  },
  createAWSLambdaAPIGatewayV2Handler: function createAWSLambdaAPIGatewayV2Handler() {
    return _createAWSLambdaAPIGatewayV2Handler;
  },
  createNodeMiddleware: function createNodeMiddleware() {
    return _createNodeMiddleware;
  },
  createWebWorkerHandler: function createWebWorkerHandler() {
    return _createWebWorkerHandler;
  },
  handleRequest: function handleRequest() {
    return _handleRequest;
  },
  sendNodeResponse: function sendNodeResponse() {
    return sendResponse;
  },
  unknownRouteResponse: function unknownRouteResponse() {
    return _unknownRouteResponse;
  }
});

module.exports = __toCommonJS(dist_src_exports);

var import_auth_oauth_app = require("@octokit/auth-oauth-app"); // pkg/dist-src/version.js


var VERSION = "6.0.0"; // pkg/dist-src/add-event-handler.js

function addEventHandler(state, eventName, eventHandler) {
  if (Array.isArray(eventName)) {
    var _iterator2 = _createForOfIteratorHelper(eventName),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var singleEventName = _step2.value;
        addEventHandler(state, singleEventName, eventHandler);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return;
  }

  if (!state.eventHandlers[eventName]) {
    state.eventHandlers[eventName] = [];
  }

  state.eventHandlers[eventName].push(eventHandler);
} // pkg/dist-src/oauth-app-octokit.js


var import_core = require("@octokit/core");

var import_universal_user_agent = require("universal-user-agent");

var OAuthAppOctokit = import_core.Octokit.defaults({
  userAgent: "octokit-oauth-app.js/".concat(VERSION, " ").concat((0, import_universal_user_agent.getUserAgent)())
}); // pkg/dist-src/methods/get-user-octokit.js

var import_auth_oauth_user = require("@octokit/auth-oauth-user"); // pkg/dist-src/emit-event.js


function emitEvent(_x, _x2) {
  return _emitEvent.apply(this, arguments);
} // pkg/dist-src/methods/get-user-octokit.js


function _emitEvent() {
  _emitEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(state, context) {
    var name, action, _iterator3, _step3, eventHandler, _iterator4, _step4, _eventHandler;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            name = context.name, action = context.action;

            if (!state.eventHandlers["".concat(name, ".").concat(action)]) {
              _context6.next = 19;
              break;
            }

            _iterator3 = _createForOfIteratorHelper(state.eventHandlers["".concat(name, ".").concat(action)]);
            _context6.prev = 3;

            _iterator3.s();

          case 5:
            if ((_step3 = _iterator3.n()).done) {
              _context6.next = 11;
              break;
            }

            eventHandler = _step3.value;
            _context6.next = 9;
            return eventHandler(context);

          case 9:
            _context6.next = 5;
            break;

          case 11:
            _context6.next = 16;
            break;

          case 13:
            _context6.prev = 13;
            _context6.t0 = _context6["catch"](3);

            _iterator3.e(_context6.t0);

          case 16:
            _context6.prev = 16;

            _iterator3.f();

            return _context6.finish(16);

          case 19:
            if (!state.eventHandlers[name]) {
              _context6.next = 37;
              break;
            }

            _iterator4 = _createForOfIteratorHelper(state.eventHandlers[name]);
            _context6.prev = 21;

            _iterator4.s();

          case 23:
            if ((_step4 = _iterator4.n()).done) {
              _context6.next = 29;
              break;
            }

            _eventHandler = _step4.value;
            _context6.next = 27;
            return _eventHandler(context);

          case 27:
            _context6.next = 23;
            break;

          case 29:
            _context6.next = 34;
            break;

          case 31:
            _context6.prev = 31;
            _context6.t1 = _context6["catch"](21);

            _iterator4.e(_context6.t1);

          case 34:
            _context6.prev = 34;

            _iterator4.f();

            return _context6.finish(34);

          case 37:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[3, 13, 16, 19], [21, 31, 34, 37]]);
  }));
  return _emitEvent.apply(this, arguments);
}

function getUserOctokitWithState(_x3, _x4) {
  return _getUserOctokitWithState.apply(this, arguments);
} // pkg/dist-src/methods/get-web-flow-authorization-url.js


function _getUserOctokitWithState() {
  _getUserOctokitWithState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(state, options) {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", state.octokit.auth(_objectSpread(_objectSpread({
              type: "oauth-user"
            }, options), {}, {
              factory: function factory(options2) {
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                  var octokit, authentication;
                  return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          octokit = new state.Octokit({
                            authStrategy: import_auth_oauth_user.createOAuthUserAuth,
                            auth: options2
                          });
                          _context7.next = 3;
                          return octokit.auth({
                            type: "get"
                          });

                        case 3:
                          authentication = _context7.sent;
                          _context7.next = 6;
                          return emitEvent(state, {
                            name: "token",
                            action: "created",
                            token: authentication.token,
                            scopes: authentication.scopes,
                            authentication: authentication,
                            octokit: octokit
                          });

                        case 6:
                          return _context7.abrupt("return", octokit);

                        case 7:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7);
                }))();
              }
            })));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _getUserOctokitWithState.apply(this, arguments);
}

var OAuthMethods = __toESM(require("@octokit/oauth-methods"));

function getWebFlowAuthorizationUrlWithState(state, options) {
  var _state$allowSignup, _options$redirectUrl, _options$scopes;

  var optionsWithDefaults = _objectSpread(_objectSpread({
    clientId: state.clientId,
    request: state.octokit.request
  }, options), {}, {
    allowSignup: (_state$allowSignup = state.allowSignup) !== null && _state$allowSignup !== void 0 ? _state$allowSignup : options.allowSignup,
    redirectUrl: (_options$redirectUrl = options.redirectUrl) !== null && _options$redirectUrl !== void 0 ? _options$redirectUrl : state.redirectUrl,
    scopes: (_options$scopes = options.scopes) !== null && _options$scopes !== void 0 ? _options$scopes : state.defaultScopes
  });

  return OAuthMethods.getWebFlowAuthorizationUrl(_objectSpread({
    clientType: state.clientType
  }, optionsWithDefaults));
} // pkg/dist-src/methods/create-token.js


var OAuthAppAuth = __toESM(require("@octokit/auth-oauth-app"));

function createTokenWithState(_x5, _x6) {
  return _createTokenWithState.apply(this, arguments);
} // pkg/dist-src/methods/check-token.js


function _createTokenWithState() {
  _createTokenWithState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(state, options) {
    var authentication;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return state.octokit.auth(_objectSpread({
              type: "oauth-user"
            }, options));

          case 2:
            authentication = _context9.sent;
            _context9.next = 5;
            return emitEvent(state, {
              name: "token",
              action: "created",
              token: authentication.token,
              scopes: authentication.scopes,
              authentication: authentication,
              octokit: new state.Octokit({
                authStrategy: OAuthAppAuth.createOAuthUserAuth,
                auth: {
                  clientType: state.clientType,
                  clientId: state.clientId,
                  clientSecret: state.clientSecret,
                  token: authentication.token,
                  scopes: authentication.scopes,
                  refreshToken: authentication.refreshToken,
                  expiresAt: authentication.expiresAt,
                  refreshTokenExpiresAt: authentication.refreshTokenExpiresAt
                }
              })
            });

          case 5:
            return _context9.abrupt("return", {
              authentication: authentication
            });

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _createTokenWithState.apply(this, arguments);
}

var OAuthMethods2 = __toESM(require("@octokit/oauth-methods"));

function checkTokenWithState(_x7, _x8) {
  return _checkTokenWithState.apply(this, arguments);
} // pkg/dist-src/methods/reset-token.js


function _checkTokenWithState() {
  _checkTokenWithState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(state, options) {
    var result;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return OAuthMethods2.checkToken(_objectSpread({
              // @ts-expect-error not worth the extra code to appease TS
              clientType: state.clientType,
              clientId: state.clientId,
              clientSecret: state.clientSecret,
              request: state.octokit.request
            }, options));

          case 2:
            result = _context10.sent;
            Object.assign(result.authentication, {
              type: "token",
              tokenType: "oauth"
            });
            return _context10.abrupt("return", result);

          case 5:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _checkTokenWithState.apply(this, arguments);
}

var OAuthMethods3 = __toESM(require("@octokit/oauth-methods"));

var import_auth_oauth_user2 = require("@octokit/auth-oauth-user");

function resetTokenWithState(_x9, _x10) {
  return _resetTokenWithState.apply(this, arguments);
} // pkg/dist-src/methods/refresh-token.js


function _resetTokenWithState() {
  _resetTokenWithState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(state, options) {
    var optionsWithDefaults, response2, authentication2, response, authentication;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            optionsWithDefaults = _objectSpread({
              clientId: state.clientId,
              clientSecret: state.clientSecret,
              request: state.octokit.request
            }, options);

            if (!(state.clientType === "oauth-app")) {
              _context11.next = 9;
              break;
            }

            _context11.next = 4;
            return OAuthMethods3.resetToken(_objectSpread({
              clientType: "oauth-app"
            }, optionsWithDefaults));

          case 4:
            response2 = _context11.sent;
            authentication2 = Object.assign(response2.authentication, {
              type: "token",
              tokenType: "oauth"
            });
            _context11.next = 8;
            return emitEvent(state, {
              name: "token",
              action: "reset",
              token: response2.authentication.token,
              scopes: response2.authentication.scopes || void 0,
              authentication: authentication2,
              octokit: new state.Octokit({
                authStrategy: import_auth_oauth_user2.createOAuthUserAuth,
                auth: {
                  clientType: state.clientType,
                  clientId: state.clientId,
                  clientSecret: state.clientSecret,
                  token: response2.authentication.token,
                  scopes: response2.authentication.scopes
                }
              })
            });

          case 8:
            return _context11.abrupt("return", _objectSpread(_objectSpread({}, response2), {}, {
              authentication: authentication2
            }));

          case 9:
            _context11.next = 11;
            return OAuthMethods3.resetToken(_objectSpread({
              clientType: "github-app"
            }, optionsWithDefaults));

          case 11:
            response = _context11.sent;
            authentication = Object.assign(response.authentication, {
              type: "token",
              tokenType: "oauth"
            });
            _context11.next = 15;
            return emitEvent(state, {
              name: "token",
              action: "reset",
              token: response.authentication.token,
              authentication: authentication,
              octokit: new state.Octokit({
                authStrategy: import_auth_oauth_user2.createOAuthUserAuth,
                auth: {
                  clientType: state.clientType,
                  clientId: state.clientId,
                  clientSecret: state.clientSecret,
                  token: response.authentication.token
                }
              })
            });

          case 15:
            return _context11.abrupt("return", _objectSpread(_objectSpread({}, response), {}, {
              authentication: authentication
            }));

          case 16:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _resetTokenWithState.apply(this, arguments);
}

var OAuthMethods4 = __toESM(require("@octokit/oauth-methods"));

var import_auth_oauth_user3 = require("@octokit/auth-oauth-user");

function refreshTokenWithState(_x11, _x12) {
  return _refreshTokenWithState.apply(this, arguments);
} // pkg/dist-src/methods/scope-token.js


function _refreshTokenWithState() {
  _refreshTokenWithState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(state, options) {
    var response, authentication;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            if (!(state.clientType === "oauth-app")) {
              _context12.next = 2;
              break;
            }

            throw new Error("[@octokit/oauth-app] app.refreshToken() is not supported for OAuth Apps");

          case 2:
            _context12.next = 4;
            return OAuthMethods4.refreshToken({
              clientType: "github-app",
              clientId: state.clientId,
              clientSecret: state.clientSecret,
              request: state.octokit.request,
              refreshToken: options.refreshToken
            });

          case 4:
            response = _context12.sent;
            authentication = Object.assign(response.authentication, {
              type: "token",
              tokenType: "oauth"
            });
            _context12.next = 8;
            return emitEvent(state, {
              name: "token",
              action: "refreshed",
              token: response.authentication.token,
              authentication: authentication,
              octokit: new state.Octokit({
                authStrategy: import_auth_oauth_user3.createOAuthUserAuth,
                auth: {
                  clientType: state.clientType,
                  clientId: state.clientId,
                  clientSecret: state.clientSecret,
                  token: response.authentication.token
                }
              })
            });

          case 8:
            return _context12.abrupt("return", _objectSpread(_objectSpread({}, response), {}, {
              authentication: authentication
            }));

          case 9:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _refreshTokenWithState.apply(this, arguments);
}

var OAuthMethods5 = __toESM(require("@octokit/oauth-methods"));

var import_auth_oauth_user4 = require("@octokit/auth-oauth-user");

function scopeTokenWithState(_x13, _x14) {
  return _scopeTokenWithState.apply(this, arguments);
} // pkg/dist-src/methods/delete-token.js


function _scopeTokenWithState() {
  _scopeTokenWithState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(state, options) {
    var response, authentication;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            if (!(state.clientType === "oauth-app")) {
              _context13.next = 2;
              break;
            }

            throw new Error("[@octokit/oauth-app] app.scopeToken() is not supported for OAuth Apps");

          case 2:
            _context13.next = 4;
            return OAuthMethods5.scopeToken(_objectSpread({
              clientType: "github-app",
              clientId: state.clientId,
              clientSecret: state.clientSecret,
              request: state.octokit.request
            }, options));

          case 4:
            response = _context13.sent;
            authentication = Object.assign(response.authentication, {
              type: "token",
              tokenType: "oauth"
            });
            _context13.next = 8;
            return emitEvent(state, {
              name: "token",
              action: "scoped",
              token: response.authentication.token,
              authentication: authentication,
              octokit: new state.Octokit({
                authStrategy: import_auth_oauth_user4.createOAuthUserAuth,
                auth: {
                  clientType: state.clientType,
                  clientId: state.clientId,
                  clientSecret: state.clientSecret,
                  token: response.authentication.token
                }
              })
            });

          case 8:
            return _context13.abrupt("return", _objectSpread(_objectSpread({}, response), {}, {
              authentication: authentication
            }));

          case 9:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _scopeTokenWithState.apply(this, arguments);
}

var OAuthMethods6 = __toESM(require("@octokit/oauth-methods"));

var import_auth_unauthenticated = require("@octokit/auth-unauthenticated");

function deleteTokenWithState(_x15, _x16) {
  return _deleteTokenWithState.apply(this, arguments);
} // pkg/dist-src/methods/delete-authorization.js


function _deleteTokenWithState() {
  _deleteTokenWithState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(state, options) {
    var optionsWithDefaults, response;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            optionsWithDefaults = _objectSpread({
              clientId: state.clientId,
              clientSecret: state.clientSecret,
              request: state.octokit.request
            }, options);

            if (!(state.clientType === "oauth-app")) {
              _context14.next = 7;
              break;
            }

            _context14.next = 4;
            return OAuthMethods6.deleteToken(_objectSpread({
              clientType: "oauth-app"
            }, optionsWithDefaults));

          case 4:
            _context14.t0 = _context14.sent;
            _context14.next = 10;
            break;

          case 7:
            _context14.next = 9;
            return OAuthMethods6.deleteToken(_objectSpread({
              clientType: "github-app"
            }, optionsWithDefaults));

          case 9:
            _context14.t0 = _context14.sent;

          case 10:
            response = _context14.t0;
            _context14.next = 13;
            return emitEvent(state, {
              name: "token",
              action: "deleted",
              token: options.token,
              octokit: new state.Octokit({
                authStrategy: import_auth_unauthenticated.createUnauthenticatedAuth,
                auth: {
                  reason: "Handling \"token.deleted\" event. The access for the token has been revoked."
                }
              })
            });

          case 13:
            return _context14.abrupt("return", response);

          case 14:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _deleteTokenWithState.apply(this, arguments);
}

var OAuthMethods7 = __toESM(require("@octokit/oauth-methods"));

var import_auth_unauthenticated2 = require("@octokit/auth-unauthenticated");

function deleteAuthorizationWithState(_x17, _x18) {
  return _deleteAuthorizationWithState.apply(this, arguments);
} // pkg/dist-src/middleware/unknown-route-response.js


function _deleteAuthorizationWithState() {
  _deleteAuthorizationWithState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(state, options) {
    var optionsWithDefaults, response;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            optionsWithDefaults = _objectSpread({
              clientId: state.clientId,
              clientSecret: state.clientSecret,
              request: state.octokit.request
            }, options);

            if (!(state.clientType === "oauth-app")) {
              _context15.next = 7;
              break;
            }

            _context15.next = 4;
            return OAuthMethods7.deleteAuthorization(_objectSpread({
              clientType: "oauth-app"
            }, optionsWithDefaults));

          case 4:
            _context15.t0 = _context15.sent;
            _context15.next = 10;
            break;

          case 7:
            _context15.next = 9;
            return OAuthMethods7.deleteAuthorization(_objectSpread({
              clientType: "github-app"
            }, optionsWithDefaults));

          case 9:
            _context15.t0 = _context15.sent;

          case 10:
            response = _context15.t0;
            _context15.next = 13;
            return emitEvent(state, {
              name: "token",
              action: "deleted",
              token: options.token,
              octokit: new state.Octokit({
                authStrategy: import_auth_unauthenticated2.createUnauthenticatedAuth,
                auth: {
                  reason: "Handling \"token.deleted\" event. The access for the token has been revoked."
                }
              })
            });

          case 13:
            _context15.next = 15;
            return emitEvent(state, {
              name: "authorization",
              action: "deleted",
              token: options.token,
              octokit: new state.Octokit({
                authStrategy: import_auth_unauthenticated2.createUnauthenticatedAuth,
                auth: {
                  reason: "Handling \"authorization.deleted\" event. The access for the app has been revoked."
                }
              })
            });

          case 15:
            return _context15.abrupt("return", response);

          case 16:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _deleteAuthorizationWithState.apply(this, arguments);
}

function _unknownRouteResponse(request) {
  return {
    status: 404,
    headers: {
      "content-type": "application/json"
    },
    text: JSON.stringify({
      error: "Unknown route: ".concat(request.method, " ").concat(request.url)
    })
  };
} // pkg/dist-src/middleware/handle-request.js


function _handleRequest(_x19, _x20, _x21) {
  return _handleRequest2.apply(this, arguments);
} // pkg/dist-src/middleware/node/parse-request.js


function _handleRequest2() {
  _handleRequest2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(app, _ref, request) {
    var _ref$pathPrefix, pathPrefix, _URL, pathname, route, routes, json, text, _URL2, searchParams, query, headers, _headers$authorizatio6, _app$getWebFlowAuthor, url, _yield$app$createToke, token2, _json, code, redirectUrl, result, _headers$authorizatio, _token, _result, _headers$authorizatio2, _token2, _result2, _headers$authorizatio3, _token3, _json2, refreshToken2, _result3, _headers$authorizatio4, _token4, _result4, _headers$authorizatio5, _token5, token;

    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _ref$pathPrefix = _ref.pathPrefix, pathPrefix = _ref$pathPrefix === void 0 ? "/api/github/oauth" : _ref$pathPrefix;

            if (!(request.method === "OPTIONS")) {
              _context16.next = 3;
              break;
            }

            return _context16.abrupt("return", {
              status: 200,
              headers: {
                "access-control-allow-origin": "*",
                "access-control-allow-methods": "*",
                "access-control-allow-headers": "Content-Type, User-Agent, Authorization"
              }
            });

          case 3:
            _URL = new URL(request.url, "http://localhost"), pathname = _URL.pathname;

            if (pathname.startsWith("".concat(pathPrefix, "/"))) {
              _context16.next = 6;
              break;
            }

            return _context16.abrupt("return", void 0);

          case 6:
            pathname = pathname.slice(pathPrefix.length + 1);
            route = [request.method, pathname].join(" ");
            routes = {
              getLogin: "GET login",
              getCallback: "GET callback",
              createToken: "POST token",
              getToken: "GET token",
              patchToken: "PATCH token",
              patchRefreshToken: "PATCH refresh-token",
              scopeToken: "POST token/scoped",
              deleteToken: "DELETE token",
              deleteGrant: "DELETE grant"
            };

            if (Object.values(routes).includes(route)) {
              _context16.next = 11;
              break;
            }

            return _context16.abrupt("return", _unknownRouteResponse(request));

          case 11:
            _context16.prev = 11;
            _context16.next = 14;
            return request.text();

          case 14:
            text = _context16.sent;
            json = text ? JSON.parse(text) : {};
            _context16.next = 21;
            break;

          case 18:
            _context16.prev = 18;
            _context16.t0 = _context16["catch"](11);
            return _context16.abrupt("return", {
              status: 400,
              headers: {
                "content-type": "application/json",
                "access-control-allow-origin": "*"
              },
              text: JSON.stringify({
                error: "[@octokit/oauth-app] request error"
              })
            });

          case 21:
            _URL2 = new URL(request.url, "http://localhost"), searchParams = _URL2.searchParams;
            query = Object.fromEntries(searchParams);
            headers = request.headers;
            _context16.prev = 24;

            if (!(route === routes.getLogin)) {
              _context16.next = 28;
              break;
            }

            _app$getWebFlowAuthor = app.getWebFlowAuthorizationUrl({
              state: query.state,
              scopes: query.scopes ? query.scopes.split(",") : void 0,
              allowSignup: query.allowSignup ? query.allowSignup === "true" : void 0,
              redirectUrl: query.redirectUrl
            }), url = _app$getWebFlowAuthor.url;
            return _context16.abrupt("return", {
              status: 302,
              headers: {
                location: url
              }
            });

          case 28:
            if (!(route === routes.getCallback)) {
              _context16.next = 38;
              break;
            }

            if (!query.error) {
              _context16.next = 31;
              break;
            }

            throw new Error("[@octokit/oauth-app] ".concat(query.error, " ").concat(query.error_description));

          case 31:
            if (query.code) {
              _context16.next = 33;
              break;
            }

            throw new Error('[@octokit/oauth-app] "code" parameter is required');

          case 33:
            _context16.next = 35;
            return app.createToken({
              code: query.code
            });

          case 35:
            _yield$app$createToke = _context16.sent;
            token2 = _yield$app$createToke.authentication.token;
            return _context16.abrupt("return", {
              status: 200,
              headers: {
                "content-type": "text/html"
              },
              text: "<h1>Token created successfully</h1>\n\n<p>Your token is: <strong>".concat(token2, "</strong>. Copy it now as it cannot be shown again.</p>")
            });

          case 38:
            if (!(route === routes.createToken)) {
              _context16.next = 47;
              break;
            }

            _json = json, code = _json.code, redirectUrl = _json.redirectUrl;

            if (code) {
              _context16.next = 42;
              break;
            }

            throw new Error('[@octokit/oauth-app] "code" parameter is required');

          case 42:
            _context16.next = 44;
            return app.createToken({
              code: code,
              redirectUrl: redirectUrl
            });

          case 44:
            result = _context16.sent;
            delete result.authentication.clientSecret;
            return _context16.abrupt("return", {
              status: 201,
              headers: {
                "content-type": "application/json",
                "access-control-allow-origin": "*"
              },
              text: JSON.stringify(result)
            });

          case 47:
            if (!(route === routes.getToken)) {
              _context16.next = 56;
              break;
            }

            _token = (_headers$authorizatio = headers.authorization) === null || _headers$authorizatio === void 0 ? void 0 : _headers$authorizatio.substr("token ".length);

            if (_token) {
              _context16.next = 51;
              break;
            }

            throw new Error('[@octokit/oauth-app] "Authorization" header is required');

          case 51:
            _context16.next = 53;
            return app.checkToken({
              token: _token
            });

          case 53:
            _result = _context16.sent;
            delete _result.authentication.clientSecret;
            return _context16.abrupt("return", {
              status: 200,
              headers: {
                "content-type": "application/json",
                "access-control-allow-origin": "*"
              },
              text: JSON.stringify(_result)
            });

          case 56:
            if (!(route === routes.patchToken)) {
              _context16.next = 65;
              break;
            }

            _token2 = (_headers$authorizatio2 = headers.authorization) === null || _headers$authorizatio2 === void 0 ? void 0 : _headers$authorizatio2.substr("token ".length);

            if (_token2) {
              _context16.next = 60;
              break;
            }

            throw new Error('[@octokit/oauth-app] "Authorization" header is required');

          case 60:
            _context16.next = 62;
            return app.resetToken({
              token: _token2
            });

          case 62:
            _result2 = _context16.sent;
            delete _result2.authentication.clientSecret;
            return _context16.abrupt("return", {
              status: 200,
              headers: {
                "content-type": "application/json",
                "access-control-allow-origin": "*"
              },
              text: JSON.stringify(_result2)
            });

          case 65:
            if (!(route === routes.patchRefreshToken)) {
              _context16.next = 77;
              break;
            }

            _token3 = (_headers$authorizatio3 = headers.authorization) === null || _headers$authorizatio3 === void 0 ? void 0 : _headers$authorizatio3.substr("token ".length);

            if (_token3) {
              _context16.next = 69;
              break;
            }

            throw new Error('[@octokit/oauth-app] "Authorization" header is required');

          case 69:
            _json2 = json, refreshToken2 = _json2.refreshToken;

            if (refreshToken2) {
              _context16.next = 72;
              break;
            }

            throw new Error("[@octokit/oauth-app] refreshToken must be sent in request body");

          case 72:
            _context16.next = 74;
            return app.refreshToken({
              refreshToken: refreshToken2
            });

          case 74:
            _result3 = _context16.sent;
            delete _result3.authentication.clientSecret;
            return _context16.abrupt("return", {
              status: 200,
              headers: {
                "content-type": "application/json",
                "access-control-allow-origin": "*"
              },
              text: JSON.stringify(_result3)
            });

          case 77:
            if (!(route === routes.scopeToken)) {
              _context16.next = 86;
              break;
            }

            _token4 = (_headers$authorizatio4 = headers.authorization) === null || _headers$authorizatio4 === void 0 ? void 0 : _headers$authorizatio4.substr("token ".length);

            if (_token4) {
              _context16.next = 81;
              break;
            }

            throw new Error('[@octokit/oauth-app] "Authorization" header is required');

          case 81:
            _context16.next = 83;
            return app.scopeToken(_objectSpread({
              token: _token4
            }, json));

          case 83:
            _result4 = _context16.sent;
            delete _result4.authentication.clientSecret;
            return _context16.abrupt("return", {
              status: 200,
              headers: {
                "content-type": "application/json",
                "access-control-allow-origin": "*"
              },
              text: JSON.stringify(_result4)
            });

          case 86:
            if (!(route === routes.deleteToken)) {
              _context16.next = 93;
              break;
            }

            _token5 = (_headers$authorizatio5 = headers.authorization) === null || _headers$authorizatio5 === void 0 ? void 0 : _headers$authorizatio5.substr("token ".length);

            if (_token5) {
              _context16.next = 90;
              break;
            }

            throw new Error('[@octokit/oauth-app] "Authorization" header is required');

          case 90:
            _context16.next = 92;
            return app.deleteToken({
              token: _token5
            });

          case 92:
            return _context16.abrupt("return", {
              status: 204,
              headers: {
                "access-control-allow-origin": "*"
              }
            });

          case 93:
            token = (_headers$authorizatio6 = headers.authorization) === null || _headers$authorizatio6 === void 0 ? void 0 : _headers$authorizatio6.substr("token ".length);

            if (token) {
              _context16.next = 96;
              break;
            }

            throw new Error('[@octokit/oauth-app] "Authorization" header is required');

          case 96:
            _context16.next = 98;
            return app.deleteAuthorization({
              token: token
            });

          case 98:
            return _context16.abrupt("return", {
              status: 204,
              headers: {
                "access-control-allow-origin": "*"
              }
            });

          case 101:
            _context16.prev = 101;
            _context16.t1 = _context16["catch"](24);
            return _context16.abrupt("return", {
              status: 400,
              headers: {
                "content-type": "application/json",
                "access-control-allow-origin": "*"
              },
              text: JSON.stringify({
                error: _context16.t1.message
              })
            });

          case 104:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[11, 18], [24, 101]]);
  }));
  return _handleRequest2.apply(this, arguments);
}

function parseRequest(request) {
  var method = request.method,
      url = request.url,
      headers = request.headers;

  function text() {
    return _text.apply(this, arguments);
  }

  function _text() {
    _text = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var text2;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return new Promise(function (resolve, reject) {
                var bodyChunks = [];
                request.on("error", reject).on("data", function (chunk) {
                  return bodyChunks.push(chunk);
                }).on("end", function () {
                  return resolve(Buffer.concat(bodyChunks).toString());
                });
              });

            case 2:
              text2 = _context.sent;
              return _context.abrupt("return", text2);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _text.apply(this, arguments);
  }

  return {
    method: method,
    url: url,
    headers: headers,
    text: text
  };
} // pkg/dist-src/middleware/node/send-response.js


function sendResponse(octokitResponse, response) {
  response.writeHead(octokitResponse.status, octokitResponse.headers);
  response.end(octokitResponse.text);
} // pkg/dist-src/middleware/node/index.js


function _createNodeMiddleware(app) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(request, response, next) {
      var octokitRequest, octokitResponse;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return parseRequest(request);

            case 2:
              octokitRequest = _context2.sent;
              _context2.next = 5;
              return _handleRequest(app, options, octokitRequest);

            case 5:
              octokitResponse = _context2.sent;

              if (!octokitResponse) {
                _context2.next = 11;
                break;
              }

              sendResponse(octokitResponse, response);
              return _context2.abrupt("return", true);

            case 11:
              next === null || next === void 0 ? void 0 : next();
              return _context2.abrupt("return", false);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x22, _x23, _x24) {
      return _ref2.apply(this, arguments);
    };
  }();
} // pkg/dist-src/middleware/web-worker/parse-request.js


function parseRequest2(request) {
  var headers = Object.fromEntries(request.headers.entries());
  return {
    method: request.method,
    url: request.url,
    headers: headers,
    text: function text() {
      return request.text();
    }
  };
} // pkg/dist-src/middleware/web-worker/send-response.js


function sendResponse2(octokitResponse) {
  return new Response(octokitResponse.text, {
    status: octokitResponse.status,
    headers: octokitResponse.headers
  });
} // pkg/dist-src/middleware/web-worker/index.js


function _createWebWorkerHandler(app) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(request) {
      var octokitRequest, octokitResponse;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return parseRequest2(request);

            case 2:
              octokitRequest = _context3.sent;
              _context3.next = 5;
              return _handleRequest(app, options, octokitRequest);

            case 5:
              octokitResponse = _context3.sent;
              return _context3.abrupt("return", octokitResponse ? sendResponse2(octokitResponse) : void 0);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x25) {
      return _ref3.apply(this, arguments);
    };
  }();
} // pkg/dist-src/middleware/aws-lambda/api-gateway-v2-parse-request.js


function parseRequest3(request) {
  var method = request.requestContext.http.method;
  var url = request.rawPath;
  var stage = request.requestContext.stage;
  if (url.startsWith("/" + stage)) url = url.substring(stage.length + 1);
  if (request.rawQueryString) url += "?" + request.rawQueryString;
  var headers = request.headers;

  var text = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", request.body || "");

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function text() {
      return _ref4.apply(this, arguments);
    };
  }();

  return {
    method: method,
    url: url,
    headers: headers,
    text: text
  };
} // pkg/dist-src/middleware/aws-lambda/api-gateway-v2-send-response.js


function sendResponse3(octokitResponse) {
  return {
    statusCode: octokitResponse.status,
    headers: octokitResponse.headers,
    body: octokitResponse.text
  };
} // pkg/dist-src/middleware/aws-lambda/api-gateway-v2.js


function _createAWSLambdaAPIGatewayV2Handler(app) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(event) {
      var request, response;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              request = parseRequest3(event);
              _context5.next = 3;
              return _handleRequest(app, options, request);

            case 3:
              response = _context5.sent;
              return _context5.abrupt("return", response ? sendResponse3(response) : void 0);

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x26) {
      return _ref5.apply(this, arguments);
    };
  }();
} // pkg/dist-src/index.js


var _OAuthApp = (_class = /*#__PURE__*/function () {
  function _OAuthApp(options) {
    _classCallCheck(this, _OAuthApp);

    var Octokit2 = options.Octokit || OAuthAppOctokit;
    this.type = options.clientType || "oauth-app";
    var octokit = new Octokit2({
      authStrategy: import_auth_oauth_app.createOAuthAppAuth,
      auth: {
        clientType: this.type,
        clientId: options.clientId,
        clientSecret: options.clientSecret
      }
    });
    var state = {
      clientType: this.type,
      clientId: options.clientId,
      clientSecret: options.clientSecret,
      // @ts-expect-error defaultScopes not permitted for GitHub Apps
      defaultScopes: options.defaultScopes || [],
      allowSignup: options.allowSignup,
      baseUrl: options.baseUrl,
      redirectUrl: options.redirectUrl,
      log: options.log,
      Octokit: Octokit2,
      octokit: octokit,
      eventHandlers: {}
    };
    this.on = addEventHandler.bind(null, state);
    this.octokit = octokit;
    this.getUserOctokit = getUserOctokitWithState.bind(null, state);
    this.getWebFlowAuthorizationUrl = getWebFlowAuthorizationUrlWithState.bind(null, state);
    this.createToken = createTokenWithState.bind(null, state);
    this.checkToken = checkTokenWithState.bind(null, state);
    this.resetToken = resetTokenWithState.bind(null, state);
    this.refreshToken = refreshTokenWithState.bind(null, state);
    this.scopeToken = scopeTokenWithState.bind(null, state);
    this.deleteToken = deleteTokenWithState.bind(null, state);
    this.deleteAuthorization = deleteAuthorizationWithState.bind(null, state);
  }

  _createClass(_OAuthApp, null, [{
    key: "defaults",
    value: function defaults(_defaults) {
      var OAuthAppWithDefaults = /*#__PURE__*/function (_this) {
        _inherits(OAuthAppWithDefaults, _this);

        var _super = _createSuper(OAuthAppWithDefaults);

        function OAuthAppWithDefaults() {
          _classCallCheck(this, OAuthAppWithDefaults);

          return _super.call(this, _objectSpread(_objectSpread({}, _defaults), arguments.length <= 0 ? undefined : arguments[0]));
        }

        return _createClass(OAuthAppWithDefaults);
      }(this);

      return OAuthAppWithDefaults;
    }
  }]);

  return _OAuthApp;
}(), _class.VERSION = VERSION, _class); // Annotate the CommonJS export names for ESM import in node:


0 && (module.exports = {
  OAuthApp: _OAuthApp,
  createAWSLambdaAPIGatewayV2Handler: _createAWSLambdaAPIGatewayV2Handler,
  createNodeMiddleware: _createNodeMiddleware,
  createWebWorkerHandler: _createWebWorkerHandler,
  handleRequest: _handleRequest,
  sendNodeResponse: sendNodeResponse,
  unknownRouteResponse: _unknownRouteResponse
});